import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class HotelPolicyCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	public base = createFeatureIslandCategoryStore({
		title: "基本設定",
		description: "",
		isBasicSetup: true,
	});

	public amenities = createFeatureIslandCategoryStore({
		title: "アメニティ・設備",
		description: "",
		isBasicSetup: true,
	});

	public cancelPolicy = createFeatureIslandCategoryStore({
		title: "キャンセルポリシー",
		description: "",
		isBasicSetup: true,
	});

	public kidsPolicy = createFeatureIslandCategoryStore({
		title: "キッズポリシー",
		description: "",
		isBasicSetup: true,
	});

	public reservationBaseSettings = createFeatureIslandCategoryStore({
		title: "予約基本設定",
		description: "",
		isBasicSetup: false,
	});

	public reservationPlanSettings = createFeatureIslandCategoryStore({
		title: "プラン",
		description: "",
		isBasicSetup: false,
	});

	public reservationQuestionSettings = createFeatureIslandCategoryStore({
		title: "事前質問",
		description: "",
		isBasicSetup: false,
	});

	public postBookingSurveySettings = createFeatureIslandCategoryStore({
		title: "予約後アンケート",
		description: "",
		isBasicSetup: false,
	});

	public reservationLocalPaymentSettings = createFeatureIslandCategoryStore({
		title: "現地決済",
		description: "",
		isBasicSetup: false,
	});

	public reservationRequestReservationSettings = createFeatureIslandCategoryStore({
		title: "リクエスト予約",
		description: "",
		isBasicSetup: false,
	});

	public reservationAdditionalFeeSettings = createFeatureIslandCategoryStore({
		title: "宿泊税など",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [
		this.base,
		this.amenities,
		this.cancelPolicy,
		this.kidsPolicy,
		this.reservationBaseSettings,
		this.reservationPlanSettings,
		this.reservationQuestionSettings,
		this.postBookingSurveySettings,
		this.reservationLocalPaymentSettings,
		this.reservationRequestReservationSettings,
		this.reservationAdditionalFeeSettings,
	];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const hotelPolicyCategoriesAndManagerStore = new HotelPolicyCategoriesAndManagerStore();
